class GuestUserIdentity {
  getUserId() {
    return "guest";
  }
  async getIdToken() {
    return void 0;
  }
  getProfile() {
    return {
      email: "guest@example.com",
      displayName: "Guest"
    };
  }
  async getProfileInfo() {
    return {
      email: "guest@example.com",
      displayName: "Guest"
    };
  }
  async getBackstageIdentity() {
    const userEntityRef = `user:default/guest`;
    return {
      type: "user",
      userEntityRef,
      ownershipEntityRefs: [userEntityRef]
    };
  }
  async getCredentials() {
    return {};
  }
  async signOut() {
  }
}

export { GuestUserIdentity };
//# sourceMappingURL=GuestUserIdentity.esm.js.map
